(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevinity-about-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sevinity-about-hero[data-video-embed-src]').forEach(function (root) {
    if (root.dataset.videoModalBound === 'true') return;
    root.dataset.videoModalBound = 'true';

    var trigger = root.querySelector('[data-video-modal-trigger]');
    var dialog = root.querySelector('[data-video-modal]');
    var player = root.querySelector('[data-video-modal-player]');
    var closeButton = root.querySelector('[data-video-modal-close]');
    var embedSrc = root.getAttribute('data-video-embed-src');
    var videoTitle = root.getAttribute('data-video-title') || 'Video';

    if (!trigger || !dialog || !player || !embedSrc) return;

    var stopVideo = function () {
      var iframe = player.querySelector('iframe');
      if (iframe) iframe.removeAttribute('src');
    };

    var startVideo = function () {
      var iframe = player.querySelector('iframe');

      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.className = 'sevinity-about-hero__video-dialog-iframe';
        iframe.setAttribute('title', videoTitle);
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        player.appendChild(iframe);
      }

      iframe.setAttribute('src', embedSrc);
    };

    trigger.addEventListener('click', function () {
      startVideo();
      dialog.showModal();
    });

    closeButton?.addEventListener('click', function () {
      stopVideo();
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        stopVideo();
        dialog.close();
      }
    });

    dialog.addEventListener('close', stopVideo);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevinity-feature-band"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sevinity-open-rewarded-video]').forEach(function (button) {
    if (button.dataset.rewardedVideoBound === 'true') return;
    button.dataset.rewardedVideoBound = 'true';

    button.addEventListener('click', function () {
      var heroTrigger = document.querySelector('.sevinity-rewarded-hero [data-video-modal-trigger]');
      if (heroTrigger) {
        heroTrigger.click();
        return;
      }

      var fallbackHref = button.getAttribute('data-video-fallback-href');
      if (fallbackHref) {
        window.open(fallbackHref, '_blank', 'noopener');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevinity-media-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sevinity-media-carousel')) {
    customElements.define(
      'sevinity-media-carousel',
      class SevinityMediaCarousel extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-carousel-track]');
          this.slidesEl = this.querySelector('[data-carousel-slides]');
          this.dotsEl = this.querySelector('[data-carousel-dots]');
          this.prevBtn = this.querySelector('[data-carousel-prev]');
          this.nextBtn = this.querySelector('[data-carousel-next]');

          if (!this.viewport || !this.slidesEl) return;

          this.abortController = new AbortController();
          const { signal } = this.abortController;

          this.onScroll = this.syncControls.bind(this);
          this.viewport.addEventListener('scroll', this.onScroll, { passive: true, signal });
          this.viewport.addEventListener('keydown', this.onKeydown.bind(this), { signal });
          window.addEventListener('resize', this.onScroll, { passive: true, signal });

          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => this.scrollBySlide(-1), { signal });
          }
          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.scrollBySlide(1), { signal });
          }

          this.dotsEl?.addEventListener(
            'click',
            (event) => {
              const dot = event.target.closest('[data-carousel-dot]');
              if (!dot || !this.dotsEl.contains(dot)) return;
              const index = Array.from(this.dotsEl.querySelectorAll('[data-carousel-dot]')).indexOf(dot);
              this.scrollToIndex(index);
            },
            { signal }
          );

          this.loadFeed(signal).finally(() => {
            this.rebuildDots();
            this.syncControls();
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        slides() {
          return Array.from(this.slidesEl?.children || []);
        }

        slideMetrics() {
          const slides = this.slides();
          const first = slides[0];
          if (!first) return { amount: this.viewport.clientWidth, count: 0 };

          const styles = getComputedStyle(this.slidesEl);
          const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return {
            amount: first.getBoundingClientRect().width + gap,
            count: slides.length,
          };
        }

        nearestIndex() {
          const { amount, count } = this.slideMetrics();
          if (!amount || !count) return 0;
          return Math.max(0, Math.min(count - 1, Math.round(this.viewport.scrollLeft / amount)));
        }

        scrollToIndex(index) {
          const { amount, count } = this.slideMetrics();
          if (!count) return;
          const target = Math.max(0, Math.min(count - 1, index));
          this.viewport.scrollTo({
            left: amount * target,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }

        scrollBySlide(direction) {
          this.scrollToIndex(this.nearestIndex() + direction);
        }

        onKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollBySlide(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.scrollBySlide(1);
          }
        }

        rebuildDots() {
          if (!this.dotsEl) return;
          const count = this.slides().length;
          const current = this.nearestIndex();
          this.dotsEl.innerHTML = '';

          if (count < 2) return;

          for (let index = 0; index < count; index += 1) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'sevinity-media-carousel__dot';
            button.setAttribute('data-carousel-dot', '');
            button.setAttribute('aria-label', `Slide ${index + 1} of ${count}`);
            if (index === current) {
              button.classList.add('is-active');
              button.setAttribute('aria-current', 'true');
            }
            this.dotsEl.append(button);
          }
        }

        syncControls() {
          const { count } = this.slideMetrics();
          const index = this.nearestIndex();
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth - 4);

          this.dotsEl?.querySelectorAll('[data-carousel-dot]').forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            if (active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          if (this.prevBtn) this.prevBtn.disabled = this.viewport.scrollLeft <= 4 || count < 2;
          if (this.nextBtn) {
            this.nextBtn.disabled = count < 2 || this.viewport.scrollLeft >= maxScroll;
          }
        }

        async loadFeed(signal) {
          const feedUrl = this.dataset.feedUrl?.trim();
          if (!feedUrl) return;

          const limit = Number(this.dataset.feedLimit || 12) || 12;

          try {
            const response = await fetch(feedUrl, { signal, credentials: 'omit' });
            if (!response.ok) return;
            const payload = await response.json();
            const posts = this.normalizePosts(payload).slice(0, limit);
            if (!posts.length) return;
            this.renderPosts(posts);
          } catch (error) {
            if (error?.name !== 'AbortError') {
              console.warn('Media carousel feed could not be loaded.', error);
            }
          }
        }

        normalizePosts(payload) {
          let list = [];
          if (Array.isArray(payload)) {
            list = payload;
          } else if (Array.isArray(payload?.posts)) {
            list = payload.posts;
          } else if (Array.isArray(payload?.data)) {
            list = payload.data;
          } else if (Array.isArray(payload?.items)) {
            list = payload.items;
          }

          return list
            .map((item) => {
              const mediaType = String(item.mediaType || item.media_type || '').toUpperCase();
              const videoCandidate = item.videoUrl || item.video_url || '';
              const mediaUrl = item.mediaUrl || item.media_url || item.imageUrl || item.src || '';
              const thumbnail = item.thumbnailUrl || item.thumbnail_url || '';
              const isVideo = mediaType.includes('VIDEO') || Boolean(videoCandidate);
              return {
                href: this.safeUrl(item.permalink || item.permalinkUrl || item.link || item.url || ''),
                image: this.safeUrl(thumbnail || (!isVideo ? mediaUrl : '')),
                video: this.safeUrl(isVideo ? videoCandidate || mediaUrl : ''),
                alt: this.shortAlt(item.caption || item.prunedCaption || item.alt || ''),
              };
            })
            .filter((post) => post.image || post.video);
        }

        shortAlt(value) {
          const text = String(value || '')
            .replace(/<[^>]*>/g, '')
            .replace(/\s+/g, ' ')
            .trim();
          if (!text) return 'Instagram post';
          return text.length > 120 ? `${text.slice(0, 117)}...` : text;
        }

        safeUrl(value) {
          if (!value) return '';
          try {
            const url = new URL(value, window.location.origin);
            if (url.protocol === 'http:' || url.protocol === 'https:') return url.href;
          } catch (error) {
            return '';
          }
          return '';
        }

        renderPosts(posts) {
          const fragment = document.createDocumentFragment();

          posts.forEach((post) => {
            const slide = document.createElement('li');
            slide.className = 'sevinity-media-carousel__slide';

            const media = document.createElement(post.href ? 'a' : 'div');
            media.className = 'sevinity-media-carousel__media';
            if (post.href) {
              media.href = post.href;
              media.target = '_blank';
              media.rel = 'noopener noreferrer';
            }

            if (post.video) {
              const video = document.createElement('video');
              video.className = 'sevinity-media-carousel__image';
              video.src = post.video;
              if (post.image) video.poster = post.image;
              video.muted = true;
              video.autoplay = true;
              video.loop = true;
              video.playsInline = true;
              video.setAttribute('playsinline', '');
              video.setAttribute('referrerpolicy', 'no-referrer');
              video.preload = 'metadata';
              video.play()?.catch(() => {});
              if (post.alt) video.setAttribute('aria-label', post.alt);
              media.append(video);

              const play = document.createElement('span');
              play.className = 'sevinity-media-carousel__play';
              play.setAttribute('aria-hidden', 'true');
              media.append(play);
            } else if (post.image) {
              const image = document.createElement('img');
              image.className = 'sevinity-media-carousel__image';
              image.src = post.image;
              image.alt = post.alt;
              image.loading = 'lazy';
              image.decoding = 'async';
              image.setAttribute('referrerpolicy', 'no-referrer');
              image.width = 400;
              image.height = 400;
              media.append(image);
            }

            slide.append(media);
            fragment.append(slide);
          });

          this.slidesEl.replaceChildren(fragment);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevinity-rewarded-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sevinity-rewarded-hero[data-video-embed-src]').forEach(function (root) {
    if (root.dataset.videoModalBound === 'true') return;
    root.dataset.videoModalBound = 'true';

    var trigger = root.querySelector('[data-video-modal-trigger]');
    var dialog = root.querySelector('[data-video-modal]');
    var player = root.querySelector('[data-video-modal-player]');
    var closeButton = root.querySelector('[data-video-modal-close]');
    var embedSrc = root.getAttribute('data-video-embed-src');
    var videoTitle = root.getAttribute('data-video-title') || 'Video';

    if (!trigger || !dialog || !player || !embedSrc) return;

    var stopVideo = function () {
      var iframe = player.querySelector('iframe');
      if (iframe) iframe.removeAttribute('src');
    };

    var startVideo = function () {
      var iframe = player.querySelector('iframe');

      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.className = 'sevinity-rewarded-hero__video-dialog-iframe';
        iframe.setAttribute('title', videoTitle);
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        player.appendChild(iframe);
      }

      iframe.setAttribute('src', embedSrc);
    };

    trigger.addEventListener('click', function () {
      startVideo();
      dialog.showModal();
    });

    closeButton?.addEventListener('click', function () {
      stopVideo();
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        stopVideo();
        dialog.close();
      }
    });

    dialog.addEventListener('close', stopVideo);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevinity-testimonials"] && !Shopify.designMode) return;
  try {
    
  class SevinityTestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-carousel-track]');
      const prev = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');

      if (!track || !prev || !next) return;

      const getScrollAmount = () => {
        const card = track.querySelector('.sevinity-testimonials__card');
        if (!card) return track.clientWidth;

        const styles = getComputedStyle(track.querySelector('.sevinity-testimonials__list'));
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

        return card.offsetWidth + gap;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  }

  if (!customElements.get('sevinity-testimonials-carousel')) {
    customElements.define('sevinity-testimonials-carousel', SevinityTestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
